// extracted by mini-css-extract-plugin
module.exports = {"styles":"hGsUds58Uh_-3G9e7B3Ds"};